import React, {useState,useEffect} from 'react'
import { Link } from 'react-router-dom';
import './Header.css';

import Dropdown from '../../components/Dropdown/Dropdown';

import sara1 from '../../../tmp/sara1.jpg';
import veronika1 from '../../../tmp/veronika1.jpg';
import kristina1 from '../../../tmp/kristina1.jpg';

const Header = ({
    whitebar = false
}) => {

    const tempGirls = {
        'rome' : {
            'talent': [
                {
                    "name":"Sara",
                    "image":sara1,
                    "slug":"sara"
                },
                {
                    "name":"Veronika",
                    "image":veronika1,
                    "slug":"veronika"
                },
                {
                    "name":"Angelina",
                    "image":kristina1,
                    "slug":"angelina"
                },
                {
                    "name":"Stacy",
                    "image":veronika1,
                    "slug":"stacy"
                },
                {
                    "name":"Carmen",
                    "image":sara1,
                    "slug":"carmen"
                },
                {
                    "name":"Kristina",
                    "image":kristina1,
                    "slug":"kristina"
                },
            ],
            'title': 'Rome',
            'desc' : 'Rome, a city of seductive allure, where ancient ruins whisper tales of passion and desire. Its streets pulse with sensual energy, blending timeless beauty with an intoxicating mix of pleasure and temptation.'
        },
        'milan' : {
            'talent': [
                {
                    "name":"Veronika",
                    "image":veronika1,
                    "slug":"veronika"
                },
                {
                    "name":"Angela",
                    "image":sara1,
                    "slug":"angela"
                },
                {
                    "name":"Diana",
                    "image":kristina1,
                    "slug":"diana"
                },
                {
                    "name":"Carmen",
                    "image":sara1,
                    "slug":"carmen"
                },
                {
                    "name":"Kristine",
                    "image":kristina1,
                    "slug":"kristine"
                },
                {
                    "name":"Sara",
                    "image":veronika1,
                    "slug":"sara"
                },
            ],
            'title': 'Milan',
            'desc' : 'Milan, a city of sleek elegance and irresistible charm, where fashion and desire intertwine. Beneath its sophisticated exterior lies a seductive rhythm, inviting indulgence in both luxury and lustful pleasures.'
        }
    }

    const [romeHover,setRomeHover] = useState(false)
    const [milanHover,setMilanHover] = useState(false)
    const [headerWhite,setHeaderWhite] = useState(false)
    const [headerWhiteOverride,setHeaderWhiteOverride] = useState(whitebar)

    const [romeGirl,setRomeGirl] = useState(tempGirls['rome']['talent'][0]['image'])
    const [milanGirl,setMilanGirl] = useState(tempGirls['milan']['talent'][0]['image'])

    const [menuStatus,setMenuStatus] = useState(false)

    const handleRomeHover = () => {
        setHeaderWhite(true)
        handleMilanOverOut()
        setRomeHover(true)
    }
    const handleMilanHover = () => {
        setHeaderWhite(true)
        handleRomeOverOut()
        setMilanHover(true)
    }
    const handleMenuOver = () => {
        setHeaderWhite(false)
        handleRomeOverOut()
        handleMilanOverOut()
    }
    const handleRomeOverOut = () => {
        setRomeHover(false)
    }
    const handleMilanOverOut = () => {
        setMilanHover(false)
    }
    const handleAllOut = () => {
        setMilanHover(false)
        setRomeHover(false)
    }
    const handleHeaderOut = () => {
        setHeaderWhite(false)
    }

    const changeFeaturedGirl = (i,city='rome') => {
        city === 'rome' ? 
            setRomeGirl(tempGirls[city]['talent'][i]['image']) : 
            setMilanGirl(tempGirls[city]['talent'][i]['image']) 
    }

    const handleMenuStatus = () => {
        if(menuStatus){
            setMenuStatus(false)
            if(!whitebar){
                setHeaderWhiteOverride(false)
            }
            return
        }
        setMenuStatus(true)
        setHeaderWhiteOverride(true)
    }

    useEffect(() => {
        if(whitebar){
            setHeaderWhiteOverride(true)
        }
    }, [whitebar])

    useEffect(() => {
        if(!whitebar){
            const handleScroll = () => {
                const scrollPosition = window.scrollY;
                if(scrollPosition > 100){
                    setHeaderWhiteOverride(true)
                }else {
                    if(!menuStatus)
                    {
                        setHeaderWhiteOverride(false)
                    }
                }
            };
            window.addEventListener('scroll', handleScroll);
            return () => {
                window.removeEventListener('scroll', handleScroll);
            };
        }
    }, []);

    return (
        <>
        <header className={headerWhite || headerWhiteOverride ? 'white' : ''} onPointerOut={handleHeaderOut}>
            <div className="view-container">
                <div className="menu">
                    <div className={ menuStatus ? "menu-bars open" : "menu-bars"} onPointerOver={handleMenuOver} onClick={handleMenuStatus}>
                        <span>
                            <div></div>
                            <div></div>
                        </span>
                    </div><div className="menu-locations">
                        <ul>
                            <li onPointerOver={handleRomeHover}>
                                Rome
                            </li>
                            <li onPointerOver={handleMilanHover}>
                                Milan
                            </li>
                        </ul>
                    </div>
                </div><div className="logo" onPointerOver={handleMenuOver}>
                    <Link to={'/'}>SADIDA</Link>
                </div><div className={whitebar ? "account black" : "account"} onPointerOver={handleMenuOver}>
                    <ul>
                        <li>
                            <Link to={''}>Casting</Link>
                        </li>
                        <li className="divide"></li>
                        <li>
                            <Link to={''}>Account</Link>
                        </li>
                    </ul>
                </div>
            </div>
            {
                romeHover ?
                    <div className="location-items" onPointerOver={handleRomeHover} onPointerOut={handleRomeOverOut}>
                        <div className="view-container">
                            <div className="li-left">
                                <div className="li-girl"
                                    style={{backgroundImage: `url(${romeGirl})`}}
                                ></div>
                            </div><div className="li-right">
                                <ul>
                                {
                                    tempGirls['rome']['talent'].map((girl,index) => {
                                        return <li key={index} onPointerOver={() => changeFeaturedGirl(index,'rome')} onClick={handleAllOut}>
                                                    <Link to={'/models/rome/'+girl['slug'] }> {girl['name']}</Link>
                                                </li>
                                    })
                                }
                                </ul>
                            </div><div className="li-desc">
                                <div className="location-name">{tempGirls['rome']['title']}</div>
                                <div className="location-desc">
                                    <p>{tempGirls['rome']['desc']}</p>
                                </div>
                            </div>
                        </div>
                    </div>    
                : ''
            }
            {
                milanHover ?
                    <div className="location-items" onPointerOver={handleMilanHover} onPointerOut={handleMilanOverOut}>
                        <div className="view-container">
                            <div className="li-left">
                                <div className="li-girl"
                                    style={{backgroundImage: `url(${milanGirl})`}}
                                ></div>
                            </div><div className="li-right">
                                <ul>
                                {
                                    tempGirls['milan']['talent'].map((girl,index) => {
                                        return <li key={index} onPointerOver={() => changeFeaturedGirl(index,'milan')} onClick={handleAllOut}>
                                                    <Link to={'/models/milan/'+girl['slug']}> {girl['name']}</Link>
                                                </li>
                                    })
                                }
                                </ul>
                            </div><div className="li-desc">
                                <div className="location-name">{tempGirls['milan']['title']}</div>
                                <div className="location-desc">
                                    <p>{tempGirls['milan']['desc']}</p>
                                </div>
                            </div>
                        </div>
                    </div>
            
                : ''
            }
        </header>
        {
            menuStatus ? 
                <>
                    <div className="menu-fader">
                        <div className="menu-tab scrollable">
                            <Dropdown 
                                title={'Home'}
                                linkOnly={true}
                                linkHref={'/'}  
                            />
                            <Dropdown 
                                title={'Talent'} 
                                defaultStatus={true} 
                                pad={true}
                                content={
                                    <>
                                        <div className="dropdown-menu">
                                            <p>
                                                Our agency represents the best talent in the industry, offering a diverse roster of top-tier 
                                                performers who consistently deliver exceptional results.
                                            </p>
                                            <div className="mobile-city-talent">
                                                <Dropdown
                                                    title={'Rome'}
                                                    content={
                                                        <ul>
                                                        {
                                                            tempGirls['rome']['talent'].map((girl) => {
                                                                return <Dropdown 
                                                                    title={girl['name']}
                                                                    linkOnly={true}
                                                                    linkHref={'/models/rome/'+girl['slug']}  
                                                                />
                                                            })
                                                        }
                                                        </ul>
                                                    }
                                                />
                                                <Dropdown
                                                    title={'Milan'}
                                                    content={
                                                        <ul>
                                                        {
                                                            tempGirls['milan']['talent'].map((girl) => {
                                                                return <Dropdown 
                                                                    title={girl['name']}
                                                                    linkOnly={true}
                                                                    linkHref={'/models/rome/'+girl['slug']}  
                                                                />
                                                            })
                                                        }
                                                        </ul>
                                                    }
                                                />
                                            </div>
                                            <div className="view-all-btn">
                                                <Link to={'/talent'}>View All</Link>
                                            </div>
                                        </div>
                                    </>
                                }    
                            />
                            <div className="menu-spacer"></div>
                            <Dropdown 
                                title={'Casting'}
                                linkOnly={true}
                                linkHref={'/casting'}  
                            />
                            <Dropdown 
                                title={'Account'}
                                linkOnly={true}
                                linkHref={'/account'}  
                            />
                            <Dropdown 
                                title={'Contact'}
                                linkOnly={true}
                                linkHref={'/contact'}  
                            />
                        </div>
                    </div>
                </> : ''
        }

        </>
    )

}

export default Header;